<template>
    <div>
        <!-- desktop -->
        <table class="table--separate table--responsive hide--sm hide--xs table">
            <thead>
                <tr>
                    <th class="table__th">
                        <p>
                            <span class="tooltip__info-text p-relativ"
                                >Trafic Internet pachet
                                <!-- <span class="tooltip-img tables-tooltip" data-tippy-content="1 unitate = 1 min apel efectuat/ apel primit/ 1 SMS trimis"></span> -->
                            </span>
                        </p>
                    </th>
                    <th class="table__th">Tarif voce pachet (minute efectuate/primite local si RO)</th>
                    <th class="table__th">
                        <p>
                            <span class="tooltip__info-text p-relativ"
                                >Tarif apel efectuat alte destinatii
                                <!-- <span class="tooltip-img tables-tooltip" data-tippy-content="către alte destinații din afara țării vizitate"></span> -->
                            </span>
                        </p>
                    </th>
                    <th class="table__th">
                        <p>
                            <span class="tooltip__info-text p-relativ"
                                >Tarif SMS trimis
                                <!-- <span class="tooltip-img tables-tooltip" data-tippy-content="către alte destinații din afara țării vizitate"></span> -->
                            </span>
                        </p>
                    </th>
                </tr>
            </thead>
            <tbody class="table__body">
                <tr>
                    <td class="table__td">
                        <strong v-html="data.tarif_internet_pachet"></strong>
                    </td>
                    <td class="table__td">
                        <strong v-html="data.tarif_voce_pachet"></strong>
                    </td>
                    <td class="table__td">
                        <strong v-html="data.tarif_apel_efectuat"></strong>
                    </td>
                    <td class="table__td">
                        <strong v-html="data.tarif_sms_trimis"></strong>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- mobile -->
        <table class="table--separate table--responsive hide--md hide--lg table" style="display: table">
            <thead></thead>
            <tbody class="table__body">
                <tr>
                    <td class="table__th table__td">
                        <p class="tooltip__info-text p-relativ">Trafic Internet pachet</p>
                    </td>
                    <td class="table__td">
                        <strong v-html="data.tarif_internet_pachet"></strong>
                    </td>
                </tr>
                <tr>
                    <td class="table__th table__td">
                        <p>
                            <span class="tooltip__info-text p-relativ"
                                >Tarif voce pachet (minute efectuate/primite local si RO)
                                <!-- <span class="tooltip-img tables-tooltip" data-tippy-content="1 unitate = 1 min apel efectuat/ apel primit/ 1 SMS trimis"></span> -->
                            </span>
                        </p>
                    </td>
                    <td class="table__td">
                        <strong v-html="data.tarif_voce_pachet"></strong>
                    </td>
                </tr>
                <tr>
                    <td class="table__th table__td">
                        <p>
                            <span class="tooltip__info-text p-relativ"
                                >Tarif apel efectuat alte destinatii
                                <!-- <span class="tooltip-img tables-tooltip" data-tippy-content="către alte destinații din afara țării vizitate"></span> -->
                            </span>
                        </p>
                    </td>
                    <td class="table__td">
                        <strong v-html="data.tarif_apel_efectuat"></strong>
                    </td>
                </tr>
                <tr>
                    <td class="table__th table__td">
                        <p>
                            <span class="tooltip__info-text p-relativ"
                                >Tarif SMS trimis
                                <!-- <span class="tooltip-img tables-tooltip" data-tippy-content="către alte destinații din afara țării vizitate"></span> -->
                            </span>
                        </p>
                    </td>
                    <td class="table__td">
                        <strong v-html="data.tarif_sms_trimis"></strong>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="tables-disclaimer">
            <p>Prețurile includ TVA</p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['data'],
};
</script>
